module.exports = __webpack_public_path__ + "img/sv-se-logo.7982c9d.svg";